import en from "@src/i18n/translations/compiled/en.json";
import et from "@src/i18n/translations/compiled/et.json";
import fi from "@src/i18n/translations/compiled/fi.json";
import sv from "@src/i18n/translations/compiled/sv.json";
import { FC } from "react";
import { useAppSelector } from "@src/reduxStore";
import { IntlProvider } from "react-intl";
import { Language } from "@src/i18n";

const messagesForLocale = (locale: Language) => {
  switch (locale) {
    case "fi":
      return fi;
    case "sv":
      return sv;
    case "en":
      return en;
    case "et":
      return et;
  }
};

const IntlProviderBoundary: FC = ({ children }) => {
  const locale = useAppSelector(state => state.common.language);

  return (
    <IntlProvider
      messages={messagesForLocale(locale)}
      locale={locale}
      defaultLocale="fi"
    >
      {children}
    </IntlProvider>
  );
};

export default IntlProviderBoundary;
